import { NewsWidget, WidgetHost } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';
import { sectionApi } from '@/modules/articles/api';
import { Section } from '@/modules/articles/model/section';
import { VisibleGroup } from '@/modules/articles/components/scrollers/visible-group';

export interface BaseScrollerState {
  includedSections?: string[];
  title?: string;
  titleSubstitutions?: { codes: string[]; name: string }[];
  /** Resolved section metadata, published by InfiniScroller so the header's Filter button can render pill labels. */
  sections?: Section[];
  /** Currently-visible advanced filter groups, published by InfiniScroller for the header's Filter button. */
  visibleGroups?: VisibleGroup[];
}

export abstract class BaseScroller implements NewsWidget<BaseScrollerState> {
  defaultTitle = '';
  titleSubstitutions;
  protected constructor(
    readonly id: string,
    protected section: string[],
    protected _initialState: BaseScrollerState,
    protected _shortTitle: string,
  ) {
    this.defaultTitle = _initialState.title ?? '';
    this.titleSubstitutions = _initialState.titleSubstitutions;
    this._initialState.includedSections = [];
  }

  async hasPermission(permissions: string[]) {
    const section = await Promise.allSettled(
      this.section.map(value => sectionApi.getSectionByCode(value)),
    );

    return section.some(value => value.status === 'fulfilled' && value.value.flags.authorized);
  }

  initialize(host: WidgetHost) {}

  initialState(): BaseScrollerState {
    return this._initialState;
  }

  defaultPreferences(): {} {
    return {};
  }

  get shortTitle(): JSX.Element {
    return <>{this._shortTitle}</>;
  }

  abstract get defaultRoute(): string;

  abstract get headerPanel(): JSX.Element;

  abstract headerActions({ children }: { children?: React.ReactNode }): JSX.Element;

  abstract get routes(): RouteObject[];
}
